import { formatCurrency } from '../utils/api';

// The sentinel the catalog filter uses for "products with no classification". Lives
// here because this control owns the concept — the page forwards it to the
// query as `untagged=1`.
export const UNTAGGED = '__untagged__';

// The work queue, as one toggle under the progress line.
//
// This is NOT a filter, which is why it did not move into the filter bar with
// classification and supplier. It is the job: the amount of money this screen exists
// to drive to zero, and the shortcut to the products that make it up. As one
// option inside a closed dropdown of seventeen it would stop being visible on
// arrival — and the number a user needs on arrival is exactly this one.
//
// It sits directly under the coverage bar so the two read as one statement:
// here is how far you have got, and here is what is left. It replaced a full
// row of per-classification chips carrying ₪, which put classification filtering in a
// different idiom from the two filters immediately below it, and needed a
// desktop cap, a mobile cap, an overflow control, a promotion rule and an
// embedded search to survive a real 17-classification catalog. Per-classification spend
// belongs to ניתוח רכש and the budget sheet, where it is analysis rather than
// a filter.
export default function UntaggedShortcut({ amount, active, onToggle }) {
  // Nothing left to classify — the coverage band is already saying so in its
  // done state, and a chip reading ₪0 would be an invitation to an empty list.
  if (!(amount > 0)) return null;

  return (
    <div className="untagged-shortcut">
      <button
        type="button"
        className={`cat-chip${active ? ' is-active' : ''}`}
        onClick={onToggle}
        aria-pressed={active}
      >
        <span className="cat-dot" style={{ background: 'transparent', border: '1px dashed #94a3b8' }} />
        <span className="cat-chip-name">ללא סיווג</span>
        <span className="cat-chip-amount">{formatCurrency(amount)}</span>
      </button>
      {/* Says what pressing it does. A lone chip under a progress bar is
          otherwise as likely to read as a label as a control. */}
      <span className="untagged-shortcut-hint">
        {active ? 'מוצגים המוצרים שטרם סווגו' : 'הצג רק את מה שטרם סווג'}
      </span>
    </div>
  );
}
